import {ErrorException} from './error.exception';
import {ErrorTypeEnum} from '../enums/error-type.enum';

export class InvalidFormException extends ErrorException {
  constructor(message: string = 'Por favor, revisa el formulario') {
    super(message);
    this.name = ErrorTypeEnum.INVALID_FORM;
  }
}
